/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\error.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

import {
  MAIL_ERROR,
  MAIL_ERROR_NOT,
} from '../actions/error';

export default function errorReducer(state = { mail: false }, action) {
  const result = Object.assign({}, state);
  switch (action.type) {
    case MAIL_ERROR:
      result.mail = true;
      return result;
    case MAIL_ERROR_NOT:
      result.mail = false;
      return result;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/error.js